import { formatAbsolute, formatFull, formatRelative, formatShort, formatSlot, parseTime } from '@/lib/time'

export type WhenMode = 'short' | 'relative' | 'absolute' | 'slot'

/** A time on screen. The visible form is compact; the full timestamp is in
 *  the tooltip and the `dateTime` attribute. */
export function When({ iso, mode = 'short', className }: { iso?: string | null; mode?: WhenMode; className?: string }) {
  const d = parseTime(iso)
  if (!d) return <span className={className}>—</span>
  const text =
    mode === 'relative'
      ? formatRelative(iso)
      : mode === 'absolute'
        ? formatAbsolute(iso)
        : mode === 'slot'
          ? formatSlot(iso)
          : formatShort(iso)
  return (
    <time dateTime={d.toISOString()} title={formatFull(iso)} className={className}>
      {text}
    </time>
  )
}
